export default {
    namespaced: true,
    state: {
        from_mail_form_flag: false,
        template_subject: '',
        mail_body: '',
        mail_body_text: '',
        mail_body_beefree: '',
        cookie_position: 0,
        cookie_font_color: 0,
        cookie_font_size: 0,
        old_editor_flag: false,
        html_mail_flag: false
    },
    mutations: {
        // メール作成ページからの遷移フラグをセット
        setFromMailForm(state, from_mail_form_flag) {
            state.from_mail_form_flag = from_mail_form_flag;
        },
        // テンプレート情報をセット
        setTemplateData(state, template_data) {
            state.template_subject = template_data.template_subject;
            state.mail_body = template_data.mail_body;
            state.mail_body_text = template_data.mail_body_text;
            state.mail_body_beefree = template_data.mail_body_beefree;
            state.cookie_position = template_data.cookie_position;
            state.cookie_font_color = template_data.cookie_font_color;
            state.cookie_font_size = template_data.cookie_font_size;
            state.old_editor_flag = template_data.old_editor_flag;
            state.html_mail_flag = template_data.html_mail_flag;
        }
    },
    actions: {},
    getters: {
        // メール作成ページからの遷移フラグを取得
        getFromMailForm(state) {
            return state.from_mail_form_flag;
        },
        // 件名を取得
        getTemplateSubject(state) {
            return state.template_subject;
        },
        // 本文を取得
        getMailBody(state) {
            return state.mail_body;
        },
        // 本文テキストを取得
        getMailBodyText(state) {
            return state.mail_body_text;
        },
        // 本文BeeFreeを取得
        getMailBodyBeeFree(state) {
            return state.mail_body_beefree;
        },
        // クッキー文言位置を取得
        getCookiePosition(state) {
            return state.cookie_position;
        },
        // クッキー文言色を取得
        getCookieFontColor(state) {
            return state.cookie_font_color;
        },
        // クッキー文言フォントサイズを取得
        getCookieFontSize(state) {
            return state.cookie_font_size;
        },
        // 旧エディタフラグを取得
        getOldEditorFlag(state) {
            return state.old_editor_flag;
        },
        // HTMLメールフラグを取得
        getHtmlMailFlag(state) {
            return state.html_mail_flag;
        }
    }
};
